
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("a5txT", function(module, exports) {

var $7xVCs = parcelRequire("7xVCs");

const $82982cff56793d8b$var$standalonePageTreeStateUpdater = new (0, $7xVCs.PageTreeStateUpdater)();
const $82982cff56793d8b$export$19e3952b1a66ecb = ()=>$82982cff56793d8b$var$standalonePageTreeStateUpdater;
module.exports["getStandalonePageTreeStateUpdater"] = $82982cff56793d8b$export$19e3952b1a66ecb;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("b1HmN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("kHp2S"))).ChangeEditionNotificationDialog
});
module.exports["LoadableChangeEditionNotificationDialog"] = $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6;

});

parcelRegister("kHp2S", function(module, exports) {

let $f11b404c5fa8cafa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f11b404c5fa8cafa$var$load("hhss7"),
    $f11b404c5fa8cafa$var$load("kSVGa")
]).then(()=>parcelRequire('5BDEU'));

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("ezLwY", function(module, exports) {
parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cpjd2 = parcelRequire("cpjd2");

const $a9c9343047c8f651$var$contexts = {};
const $a9c9343047c8f651$var$runSafely = (fn)=>{
    try {
        fn();
    } catch (e) {
        // TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
        console.error(e);
    }
};
const $a9c9343047c8f651$export$2cd8252107eb640b = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!confluence-keyboard-shortcuts-batch'
    ], ()=>{
        $a9c9343047c8f651$var$runSafely(()=>{
            (0, $3IK76.bind)('register-contexts.keyboardshortcuts', (e, data)=>{
                const { enableContext: enableContext } = data.shortcutRegistry;
                Object.entries($a9c9343047c8f651$var$contexts).forEach(([context, enabled])=>{
                    if (enabled) enableContext(context);
                });
            });
            (0, $3IK76.trigger)('initialize.keyboardshortcuts');
        });
    }, ()=>{});
};
const $a9c9343047c8f651$export$e758fd0259c79269 = ()=>{
    // We need to disable all shortcuts and enable again
    // the ones still available as the currrent library doesn't expose a
    // method for removing just one context and we want to keep previous
    // added contexts alive
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
        (0, $3IK76.trigger)('initialize.keyboardshortcuts');
    });
};
const $a9c9343047c8f651$var$makeSetContext = (enable)=>(newContexts)=>{
        if (!Array.isArray(newContexts)) newContexts = [
            newContexts
        ];
        newContexts.forEach((context)=>{
            if ($a9c9343047c8f651$var$contexts[context] !== enable) {
                $a9c9343047c8f651$var$contexts[context] = enable;
                $a9c9343047c8f651$export$e758fd0259c79269();
            }
        });
    };
const $a9c9343047c8f651$export$2ca78a0e32b5ba4e = $a9c9343047c8f651$var$makeSetContext(true);
const $a9c9343047c8f651$export$48a00fd3a2cf40e0 = $a9c9343047c8f651$var$makeSetContext(false);
const $a9c9343047c8f651$export$4794d9b1949031cf = ()=>{
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
    });
};
module.exports["init"] = $a9c9343047c8f651$export$2cd8252107eb640b;
module.exports["enableContext"] = $a9c9343047c8f651$export$2ca78a0e32b5ba4e;
module.exports["disableContext"] = $a9c9343047c8f651$export$48a00fd3a2cf40e0;
module.exports["teardown"] = $a9c9343047c8f651$export$4794d9b1949031cf;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("fmuCC", function(module, exports) {

let $b2f0a9f0e00b7e22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2f0a9f0e00b7e22$var$load("lgm1i").then(()=>parcelRequire('04Nru'));

});

parcelRegister("jzEl8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
function $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode = window.document) {
    if (!rootNode) return [];
    return Array.from(rootNode.querySelectorAll(selectors.join(',')));
}
function $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(domElement) {
    if (!domElement.hasAttributes()) return {};
    return Object.values(domElement.attributes).reduce((acc, attr)=>{
        acc[attr.name] = attr.value;
        return acc;
    }, {});
}
const $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 = /*#__PURE__*/ (0, $42omo.memo)(function LegacyDOMBridge({ selectors: selectors, attempts: attempts = 1, retryDelay: retryDelay = 50, rootNode: rootNode, portalNode: portalNode, replacePlaceholderWith: replacePlaceholderWith, deleteExistingContent: deleteExistingContent = true }) {
    const [portals, setPortals] = (0, $42omo.useState)([]);
    const workerInProgressRef = (0, $42omo.useRef)(false);
    const portalsRef = (0, $42omo.useRef)([]);
    const replaceDOMElementsWithPortal = (0, $42omo.useCallback)((attemptsLeft)=>{
        workerInProgressRef.current = true;
        $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode).forEach((node)=>{
            const currentNodeAttrs = $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(portalNode, currentNodeAttrs);
                portalsRef.current.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(reactEl, targetNode));
            }
        });
        const remaining = attemptsLeft - 1;
        setPortals([
            ...portalsRef.current
        ]);
        if (remaining > 0) window.setTimeout(()=>{
            replaceDOMElementsWithPortal(remaining);
        }, retryDelay);
        else workerInProgressRef.current = false;
    }, [
        selectors,
        rootNode,
        portalNode,
        replacePlaceholderWith,
        deleteExistingContent,
        retryDelay
    ]);
    (0, $42omo.useEffect)(()=>{
        if (attempts > 0 && !workerInProgressRef.current) {
            const timerId = setTimeout(()=>{
                replaceDOMElementsWithPortal(attempts);
            }, 0);
            return ()=>clearTimeout(timerId);
        }
    }, [
        attempts,
        replaceDOMElementsWithPortal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portals);
});
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("gXX8A", function(module, exports) {

let $c5a0077b00bea3b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5a0077b00bea3b8$var$load("6wr18"),
    $c5a0077b00bea3b8$var$load("ffEVr"),
    $c5a0077b00bea3b8$var$load("Wowvf"),
    $c5a0077b00bea3b8$var$load("j06N4"),
    $c5a0077b00bea3b8$var$load("hhss7"),
    $c5a0077b00bea3b8$var$load("lwfE5")
]).then(()=>parcelRequire('MkVVm'));

});

parcelRegister("2NJWg", function(module, exports) {

let $20a3cae097b49b58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20a3cae097b49b58$var$load("6wr18"),
    $20a3cae097b49b58$var$load("ffEVr"),
    $20a3cae097b49b58$var$load("Wowvf"),
    $20a3cae097b49b58$var$load("hhss7"),
    $20a3cae097b49b58$var$load("d7sp9")
]).then(()=>parcelRequire('4Au5p'));

});

parcelRegister("cq0jI", function(module, exports) {

let $90a828add24c033b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90a828add24c033b$var$load("hhss7"),
    $90a828add24c033b$var$load("ei0Jg")
]).then(()=>parcelRequire('esrJ1'));

});

parcelRegister("7nmkU", function(module, exports) {

let $55ec01e1fb53735b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55ec01e1fb53735b$var$load("hhf8b").then(()=>parcelRequire('cDa2P'));

});

parcelRegister("7Y3RT", function(module, exports) {

let $5cd1232d64c101e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5cd1232d64c101e8$var$load("1CUOt"),
    $5cd1232d64c101e8$var$load("82QsP"),
    $5cd1232d64c101e8$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});

parcelRegister("2fhln", function(module, exports) {

let $1a2a6f9ed04d27c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a2a6f9ed04d27c9$var$load("1CUOt"),
    $1a2a6f9ed04d27c9$var$load("82QsP"),
    $1a2a6f9ed04d27c9$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("14QAi", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

$parcel$global.rwr("3pblT", () => { var $7fad26ed364ec13c$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3pblT\",\"standalone-navigation-jquery3.28598375.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.bde70d07.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.2c978907.js\",\"kyxdN\",\"EditSpaceLogo.335b20d2.js\",\"gRwHT\",\"EditSpaceLogoComponent.5907602a.js\",\"dJhDI\",\"Upload.41b8806c.svg\",\"7t2Ec\",\"EditSpaceLogoGallery.0407373d.js\",\"8W6BK\",\"SpaceSelector.ec35209e.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.c798eb9b.js\",\"ffEVr\",\"vendors~editor_icon.3eda5d95.js\",\"fxC6e\",\"24.a8551207.js\",\"6vhrJ\",\"24.0038bfb9.js\",\"7EorR\",\"vendors~editor_atlaskit_md.d7ccc2d1.js\",\"fsikk\",\"cardWithMediaClient.ea8ac2db.js\",\"ehQBw\",\"EditSpaceLogoComponent.45e0d0e9.js\",\"6wr18\",\"vendors~editor_icon.f8d07104.js\",\"huUvS\",\"16.f2efe4ea.js\",\"1oiJ6\",\"16.5bb2f63a.js\",\"lxiFd\",\"16.4af6f7cd.js\",\"eDqo1\",\"16.44627fd1.js\",\"6HBYC\",\"16.f126a592.js\",\"bYxCZ\",\"16.a686bbdc.js\",\"eTBsW\",\"16.18d8d725.js\",\"020xd\",\"16.3bccb64c.js\",\"ls0Um\",\"16.6eef16fe.js\",\"eVYW1\",\"16.75064efa.js\",\"f35QR\",\"16.505024b2.js\",\"kHOMt\",\"CommentsPanelFooter.9fcbe01b.js\",\"8j9XC\",\"cardWithMediaClient.a4c11cd5.js\",\"b8BDn\",\"js.24b546d4.js\",\"dLFEp\",\"png-chunks-extract.6eed11e8.js\",\"lgm1i\",\"StandaloneRestrictedPageOrSpace.993c1d79.js\",\"gEi5K\",\"NotFound.07a401d1.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"gmdTV\",\"NotFoundLightMohiti.f3865b48.svg\",\"iE6k1\",\"NotFoundDarkMohiti.69b249fc.svg\",\"iMSgb\",\"log-in.9b553c7d.js\",\"9a2oY\",\"home.c75a599b.js\",\"kUiwW\",\"RestrictedPage.7b2155b4.js\",\"5WZOQ\",\"CantViewLight.81544b8c.svg\",\"dHMTU\",\"CantViewDark.ef25ef94.svg\",\"cOpg6\",\"CantEditLight.0ee7f232.svg\",\"37OHY\",\"CantEditDark.190a22b1.svg\",\"2OcM6\",\"RestrictedSpace.c438d87c.js\",\"6f3t8\",\"AdminKeyUpSell.9e2f5763.js\",\"5pvpJ\",\"CommentEditor.0720ad71.js\",\"cEqm7\",\"ExtensionConfigUpsell.b6ae4f1a.js\",\"6XCf4\",\"LearnMoreButton.f40f8805.js\",\"1yVM6\",\"UpgradeEditionButton.0c79e771.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.1990bcb9.js\",\"1GCFv\",\"CommentsPanelWrapper.ef24f034.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.1990bcb9.js\",\"euA5f\",\"SuperAdminEntryPoint.04638fb8.js\",\"82QsP\",\"InProductHelpButton.bc7f8513.js\",\"1CUOt\",\"InProductHelpButton.c6ba18af.js\",\"55AxV\",\"RestrictedContentIcon-Dark.bc90ae31.svg\",\"L0tFv\",\"RestrictedContentIcon-Light.e0fef1fb.svg\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.2d6def4d.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"7DDw1\",\"ConfluenceLogo.37570e84.svg\",\"daX4F\",\"Controller.5faff4f0.js\",\"4y0IB\",\"GoalPanel.e6eac26d.js\",\"k0WnS\",\"ExternalPageNotFoundV2.f17a4041.js\",\"4J5D7\",\"not-found-v2.ab9d1086.svg\",\"cj0Rr\",\"FullPageEditorComponent.a5ba4cfe.js\",\"bJaqQ\",\"simpleHasher.6caf59a1.js\",\"AJVgg\",\"simpleHasher.runtime.bfc4d0cf.js\",\"AJVgg\",\"simpleHasher.runtime.bfc4d0cf.js\",\"lwfE5\",\"ArchiveSpacePortal.c81e1bf6.js\",\"j06N4\",\"ArchiveSpacePanel.9e94b8ba.js\",\"d7sp9\",\"DeleteSpacePortal.d464b346.js\",\"ei0Jg\",\"SpaceSettingsForgeExtensionPortal.6e23c8f0.js\",\"lnKog\",\"main.801dad04.js\",\"iEUHW\",\"CommentEditor.31d77d24.js\",\"bGzhS\",\"ByLineForgeApp.2250c03c.js\",\"cjJTJ\",\"section-message.547b3afe.js\",\"bf0yj\",\"modal-dialog.4ea336eb.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"3Zwna\",\"custom-theme.a058bc4b.js\",\"cRtGo\",\"FullPageEditorComponent.66a0da6f.js\",\"kbwlB\",\"CommentEditor.3bf5f494.js\",\"2eAhv\",\"FullPageEditorComponent.44c2101e.js\",\"7qn4A\",\"FullPageEditorComponent.runtime.04e9c35f.js\",\"dfFoa\",\"FullPageEditorComponent.d4db661e.js\",\"j3SHq\",\"FullPageEditorComponent.runtime.2d0f1248.js\",\"psI7s\",\"FullPageEditorComponent.885e4668.js\",\"fIjMV\",\"FullPageEditorComponent.runtime.d63a205b.js\",\"Y2vgz\",\"FullPageEditorComponent.cc43cd7b.js\",\"7BON9\",\"FullPageEditorComponent.runtime.cb3b24db.js\",\"jbM5v\",\"CommentsPanelFilterMenu.3d0e9a52.js\",\"l22f4\",\"CommentsPanelFooter.d0317e62.js\",\"iivLa\",\"blog.7c82f93c.js\",\"9atVd\",\"bug.7d98f635.js\",\"5zapo\",\"story.f30f5865.js\",\"6SWFK\",\"task.cfed4024.js\",\"3MYQs\",\"work-item.9bce1579.js\",\"h4Nf7\",\"ExternalUserLozenge.c10c91fd.js\",\"hUmZG\",\"page.bffc9dec.js\",\"3GuOt\",\"GoalPanel.a05f7e6a.js\",\"1WXdc\",\"CommentEditor.92c962b5.js\",\"lTK3c\",\"CommentEditor.runtime.097e5a69.js\",\"bvY53\",\"CommentEditor.431c8ca6.js\",\"27glK\",\"CommentEditor.runtime.33911d1d.js\",\"h9S8v\",\"AgentProfileCardResourced.6e17bb19.js\",\"cGVng\",\"AgentProfileCard.804c5db3.js\",\"kLPE1\",\"AgentProfileCard.b920a71a.js\",\"c9Qqc\",\"auto-dev.a2c72ff7.js\",\"1TK6P\",\"auto-fix.9ad2a140.js\",\"grvAy\",\"auto-review.585c46b7.js\",\"23K0q\",\"backlog-buddy.bd9aa542.js\",\"3kQkj\",\"comms-crafter.549021d9.js\",\"6OXgE\",\"culture.a0ccd218.js\",\"cbucA\",\"customer-insight.31475362.js\",\"bVhr1\",\"decision-director.e2cef47b.js\",\"kE0QC\",\"feature-flag-avatar.1649e877.js\",\"eVFXf\",\"generic-avatar.66c77204.js\",\"9FhBz\",\"hire-writer.3a8c5b70.js\",\"6zB8z\",\"marketing-message-maestro.bf20f997.js\",\"eENGY\",\"my-user-manual.cd1eff0f.js\",\"hmlb0\",\"okr-oracle.5fb6b2fd.js\",\"2NGxc\",\"ops-agent.3957c35e.js\",\"bPgcq\",\"pitch-perfector.c0be39ec.js\",\"31b1q\",\"product-requirement.a84d5cbb.js\",\"8Lh9U\",\"release-notes.f9bdd8ca.js\",\"6ZzYJ\",\"research-scout.1f707cdb.js\",\"2zIbn\",\"rovo-dev.1bc5001b.js\",\"410SS\",\"social-media-scribe.1c796f00.js\",\"z3s9q\",\"team-connection.ff0a5995.js\",\"9gqcE\",\"workflow-builder.966c2ec7.js\",\"eipnW\",\"trial-guide.3a984dd9.js\",\"jdAk9\",\"jsm-rovo-service-agent.b0a16d69.js\",\"fbike\",\"amplitude-agent.db97cfc5.js\",\"4n4TY\",\"box-agent.581af9be.js\",\"2aX2w\",\"canva-agent.7ad22327.js\",\"dWdGk\",\"figma-agent.1f4b52cc.js\",\"hQhwm\",\"hubspot-agent.3a41646c.js\",\"7VfH7\",\"intercom-agent.01fc1ac2.js\",\"aJ4jy\",\"gamma-agent.95ce4a29.js\",\"4AOh0\",\"lovable-agent.7dc04600.js\",\"i87P0\",\"replit-agent.2a3a86ef.js\",\"aLqH7\",\"rovo-agent.c4604e94.js\",\"I6kbK\",\"jira-work-agent.aa199abe.js\",\"2K77s\",\"jira-intelligent-triage-agent.367a5fa7.js\",\"drA4N\",\"AgentProfileCard.9c7f1c34.js\",\"498jr\",\"ProfileCard.bb66c171.js\",\"kSjKH\",\"ProfileCard.0b4811b4.js\",\"cHQ50\",\"location.970afe87.js\",\"3NJJ8\",\"GoalPanel.a9b78841.js\",\"1Y6tF\",\"main.3de539fb.js\",\"85ppg\",\"FullPageEditorComponent.e679b8bd.js\",\"f69R7\",\"FullPageEditorComponent.runtime.60981474.js\",\"eBRUf\",\"definition-popup-content.7401733c.js\",\"c0JsV\",\"link-picker.5d955578.js\",\"h05Zl\",\"ufo.1597da7c.js\",\"27glK\",\"CommentEditor.runtime.33911d1d.js\",\"hoPZ9\",\"cs.95ed9e76.js\",\"gyXEE\",\"cs.d6943f17.js\",\"4DYJ5\",\"cs.cfe6dd20.js\",\"i9sd0\",\"cs.9d4bdcaa.js\",\"bv8GZ\",\"cs.b8d1c1b1.js\",\"i5eMd\",\"cs.3dc597bc.js\",\"1jsQH\",\"cs.688247af.js\",\"4Mixi\",\"cs.cbb5fe34.js\",\"2Fu3d\",\"da.d0b636a3.js\",\"1Mp9N\",\"da.70250e64.js\",\"hfFxJ\",\"da.a783daa0.js\",\"aNg21\",\"da.7e964581.js\",\"cdeuH\",\"da.42823f82.js\",\"4UPfH\",\"da.ab144495.js\",\"deyvi\",\"da.ce01a3f4.js\",\"cjveN\",\"da.835212d1.js\",\"eJgH8\",\"de.f15681b3.js\",\"dBb6q\",\"de.9cd38b10.js\",\"gofGr\",\"de.740eccdd.js\",\"YEGhv\",\"de.9855a254.js\",\"7gF8f\",\"de.8842c040.js\",\"gd4qs\",\"de.9af60d5a.js\",\"6dERU\",\"de.196d0286.js\",\"8XGJb\",\"de.a2ec1619.js\",\"7Lkvk\",\"en_GB.e2a7b52e.js\",\"2RQvP\",\"en_GB.3574186e.js\",\"d8WL7\",\"en-GB.17cdb1e1.js\",\"djb49\",\"en-GB.f6189fc2.js\",\"fviv5\",\"en-GB.67bee54b.js\",\"kTurq\",\"en-GB.d1625683.js\",\"hdvZr\",\"en_GB.702092de.js\",\"5FaEJ\",\"en_ZZ.6e2429e9.js\",\"cukQS\",\"en_ZZ.825f9259.js\",\"7NpX8\",\"en_ZZ.d7558c17.js\",\"j5F5K\",\"en-ZZ.bc70de79.js\",\"ksTQ6\",\"en-ZZ.2ced82d9.js\",\"eBoC7\",\"en-ZZ.10d251aa.js\",\"j0PWv\",\"en-ZZ.0cb183d6.js\",\"4ViGN\",\"en_ZZ.bb1eba3d.js\",\"9yemY\",\"es.1c28eadf.js\",\"3CucM\",\"es.47e1362e.js\",\"bFU3Y\",\"es.261e2e44.js\",\"dXu4x\",\"es.9fa90d0e.js\",\"5CGnz\",\"es.98f8e90e.js\",\"bNv64\",\"es.d5eb3570.js\",\"dlmud\",\"es.a37dad44.js\",\"32vlK\",\"es.ac31b31a.js\",\"l2LZP\",\"fi.248f4a99.js\",\"lp8Wm\",\"fi.ca280e0e.js\",\"exaJ2\",\"fi.7a1034cf.js\",\"18TX5\",\"fi.6b841ddb.js\",\"9Oxgj\",\"fi.f2f3389c.js\",\"4Afgd\",\"fi.f665bce4.js\",\"cbkj0\",\"fi.c129a5d2.js\",\"bjoGV\",\"fi.1e513850.js\",\"35Ssm\",\"fr.3c69b729.js\",\"cHWSM\",\"fr.6e3a4455.js\",\"hcCcg\",\"fr.a3ad4344.js\",\"9Cdzw\",\"fr.2c6ce3b7.js\",\"kAg8V\",\"fr.368a32d8.js\",\"cMubu\",\"fr.f6617ad8.js\",\"17m16\",\"fr.d48d2214.js\",\"8oiz7\",\"fr.6f53d7a9.js\",\"ik6u5\",\"hu.fe6723c8.js\",\"b37xN\",\"hu.549de1ee.js\",\"j9KTb\",\"hu.dbe8c50b.js\",\"guNAg\",\"hu.80af4923.js\",\"fM2oh\",\"hu.f2f9ae82.js\",\"3fLE9\",\"hu.d7c08200.js\",\"b4NO6\",\"hu.d63219d9.js\",\"hFxmj\",\"hu.cd9b6b61.js\",\"Vt6S9\",\"it.24082589.js\",\"7PjNK\",\"it.5f89f44b.js\",\"3hjAq\",\"it.a3613fa0.js\",\"cM3gY\",\"it.b453a55f.js\",\"xnqy2\",\"it.351ab003.js\",\"8hOn0\",\"it.33434d60.js\",\"1K1Fj\",\"it.68b18a63.js\",\"BXOZB\",\"it.99220f36.js\",\"9GZ76\",\"ja.39a9fa37.js\",\"ktSfi\",\"ja.e26ef8c3.js\",\"2bCHJ\",\"ja.b3e23338.js\",\"6yRq3\",\"ja.04fcfff4.js\",\"awkVi\",\"ja.99d2f833.js\",\"h4OCL\",\"ja.12b79d99.js\",\"38sfA\",\"ja.05e83d89.js\",\"9Xiuh\",\"ja.82009b49.js\",\"4sOIV\",\"ko.9a4210fa.js\",\"iouLY\",\"ko.404e8e4e.js\",\"fdXnq\",\"ko.f790e012.js\",\"cft22\",\"ko.4cdaa50b.js\",\"11DLa\",\"ko.8aeaf96b.js\",\"bcQs2\",\"ko.2588c045.js\",\"bjmre\",\"ko.5d08c8ec.js\",\"7Odo3\",\"ko.f8696b38.js\",\"QTjdE\",\"nb.241af90e.js\",\"hPZE5\",\"nb.841dfbd1.js\",\"cItJR\",\"nb.6a1d0441.js\",\"gctEz\",\"nb.5b39f576.js\",\"barSq\",\"nb.4503e9a5.js\",\"aBa7j\",\"nb.aa6b556f.js\",\"asvK9\",\"nb.b60c8cb7.js\",\"4VkvT\",\"nb.7fc4a303.js\",\"hrf1M\",\"nl.39edbd6a.js\",\"dzIm8\",\"nl.99e222d0.js\",\"SctKm\",\"nl.67a199c1.js\",\"9PPH7\",\"nl.b653ffd1.js\",\"a8heY\",\"nl.6070b16e.js\",\"b544F\",\"nl.37c7b2cf.js\",\"7v6wU\",\"nl.d417f24d.js\",\"g5qJV\",\"nl.27391c7e.js\",\"lsloj\",\"pl.9999c87a.js\",\"jqwnR\",\"pl.68b4abf7.js\",\"1fJz1\",\"pl.a7b186cf.js\",\"1y1eN\",\"pl.74f0670b.js\",\"6hlNE\",\"pl.9a5b0b0f.js\",\"K6fhx\",\"pl.1207c094.js\",\"aEpRh\",\"pl.26cf010d.js\",\"dPa6p\",\"pl.39ca0fea.js\",\"iRKhU\",\"pt_BR.3cc01414.js\",\"bGhLc\",\"pt_BR.3c22594a.js\",\"9yA8o\",\"pt_BR.91cf63a9.js\",\"e8jpx\",\"pt-BR.63c4ab47.js\",\"2bqSD\",\"pt-BR.10f91e79.js\",\"gZU54\",\"pt-BR.326dc26c.js\",\"3fuR9\",\"pt-BR.b55187ea.js\",\"iG4uh\",\"pt_BR.b57aad22.js\",\"aEAsN\",\"ru.a35ffd8d.js\",\"9v6ER\",\"ru.904cd8b3.js\",\"448N7\",\"ru.130b6f0d.js\",\"fjbzp\",\"ru.64950da8.js\",\"bJykp\",\"ru.2a448b30.js\",\"4Wdqb\",\"ru.f60e9b0c.js\",\"fMrUo\",\"ru.f0bbf79a.js\",\"9tVE8\",\"ru.65c56da2.js\",\"l6YHr\",\"sv.180e7e8d.js\",\"8Mz40\",\"sv.db552c03.js\",\"gBDdh\",\"sv.050c3416.js\",\"1pFHs\",\"sv.6ef3a00d.js\",\"dh2Er\",\"sv.e6031ecb.js\",\"k10Cs\",\"sv.66a51919.js\",\"9eNkX\",\"sv.12cce2b0.js\",\"6UAlo\",\"sv.575cc5b8.js\",\"jYGxH\",\"th.979bffc6.js\",\"czAFw\",\"tr.681a53e9.js\",\"c0Efy\",\"uk.94c09e9c.js\",\"dKBuH\",\"vi.58f3aadb.js\",\"afU9w\",\"zh_TW.032fae5c.js\",\"hF4v3\",\"zh_TW.0632479b.js\",\"ebljE\",\"zh_TW.73b55cef.js\",\"kKXTS\",\"zh-TW.68c4b74b.js\",\"bV8sS\",\"zh-TW.90b55434.js\",\"l079e\",\"zh-TW.3be9c0ad.js\",\"j9OUx\",\"zh-TW.9fda702e.js\",\"ia9y3\",\"zh_TW.6efc768f.js\",\"7iCpI\",\"zh.ee674e2a.js\",\"1Tuyb\",\"zh.55d45402.js\",\"j4dSZ\",\"zh.6f341e9f.js\",\"7sItg\",\"zh-CN.fdb102fa.js\",\"eLlpV\",\"zh-CN.914fb213.js\",\"f1B4n\",\"zh-CN.725f97ad.js\",\"gDiIK\",\"zh-CN.268ccaa6.js\",\"15ncj\",\"zh.f634978a.js\",\"6wmiZ\",\"FullPageEditorComponent.57749a16.js\",\"lo4Uk\",\"UserProfileMacroRenderer.004b5f82.js\",\"la1wZ\",\"FullPageEditorComponent.c4a08133.js\",\"1hq45\",\"FullPageEditorComponent.runtime.eb9d0b3a.js\",\"7o5Pu\",\"SmartButtonConfigPanel.82503903.js\",\"cy3XE\",\"ByLineForgeApp.1b0c3f25.js\",\"eNXrl\",\"ByLineForgeApp.515c0dc7.js\",\"jigcs\",\"LabelsSelect.deacac82.js\",\"718G0\",\"LabelsSelectErrors.7e2a3c95.js\",\"4LmEY\",\"ViewPageLabels.260f98e1.js\",\"kpHRm\",\"GeneralShortcutListener.e17e5cbb.js\",\"e1RjR\",\"GeneralShortcutListener.3f747bdc.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.9617c81a.js\",\"45iSI\",\"AutomationDiscoveryHoverPageTitleMessage.1bef5ea0.js\",\"jhgNc\",\"LabelsSelect.d49ab730.js\",\"6KGrg\",\"EmojiComponent.77c209a4.js\",\"kFiBp\",\"EmojiComponent.e4fef992.js\",\"hxlWB\",\"EmojiComponent.9bcde932.js\",\"ajMch\",\"16.db4694d5.js\",\"6YfM6\",\"EmojiComponent.cef490cc.js\",\"2YffH\",\"en.a4f51b29.js\",\"lTK3c\",\"CommentEditor.runtime.097e5a69.js\",\"7BON9\",\"FullPageEditorComponent.runtime.cb3b24db.js\",\"j3SHq\",\"FullPageEditorComponent.runtime.2d0f1248.js\",\"fIjMV\",\"FullPageEditorComponent.runtime.d63a205b.js\",\"f69R7\",\"FullPageEditorComponent.runtime.60981474.js\",\"7qn4A\",\"FullPageEditorComponent.runtime.04e9c35f.js\",\"1hq45\",\"FullPageEditorComponent.runtime.eb9d0b3a.js\",\"bdzih\",\"ContentActionForgeApp.10c70f2a.js\",\"cwpVK\",\"ContextMenuForgeApp.eaae8133.js\",\"68RC4\",\"FullPageForgeApp.833f57ea.js\",\"87cDu\",\"GlobalPageForgeApp.df81ab95.js\",\"iXr0W\",\"GlobalSettingsForgeApp.29ab570b.js\",\"ccJug\",\"HomepageFeedForgeApp.3043de36.js\",\"irYLY\",\"SpaceSettingsForgeApp.dbb928fd.js\",\"ldtPf\",\"SpacePageForgeApp.3968f4d3.js\",\"6wcNV\",\"CustomContentForgeApp.e74017fa.js\",\"i9jMB\",\"BackgroundScriptForgeApp.bb8714c4.js\",\"aFNXd\",\"PageBannerForgeApp.3df5a451.js\",\"hhf8b\",\"SpaceTrashPortal.a6d4f250.js\",\"an2zh\",\"SiteSettingsHelpPanelLink.48fe27c8.js\",\"gJRFC\",\"BackupManagerButton.f8c63c18.js\",\"5BbvB\",\"dashboard-spa-container-jquery3.4ce3f13c.js\",\"lgZdI\",\"dashboard-spa-container-jquery3.runtime.94043877.js\",\"aZinD\",\"vendors.c392c454.js\",\"eiF7i\",\"stable_vendors.2f3ed946.js\"]"));
 }, ["7EorR","5BbvB","lgZdI","aZinD","eiF7i","hhss7","ffEVr","5pvpJ","cEqm7","6XCf4","1yVM6","1qlDN","6wr18"]);
$parcel$global.rwr("3pblT", () => { 
var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5QpZa = parcelRequire("5QpZa");


var $hp2SH = parcelRequire("hp2SH");


var $iC5L0 = parcelRequire("iC5L0");


var $aXEzU = parcelRequire("aXEzU");





var $3WLLD = parcelRequire("3WLLD");


var $bj5fB = parcelRequire("bj5fB");





var $7J5Uc = parcelRequire("7J5Uc");

const $14d55bbfca2abbc5$export$7a88623f52f1b79 = (initialTheme)=>{
    const [{ isInitialized: isInitialized }, { initializeTheme: initializeTheme }] = (0, $7J5Uc.useThemingState)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};


const $e6baa9171970034d$export$11eb671888ed6e7d = ({ children: children })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    const isInitialized = (0, $14d55bbfca2abbc5$export$7a88623f52f1b79)(initialTheme);
    if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $7zgzO = parcelRequire("7zgzO");


var $awd1Q = parcelRequire("awd1Q");


var $9j59h = parcelRequire("9j59h");


var $xwvlW = parcelRequire("xwvlW");


var $8PKGr = parcelRequire("8PKGr");


var $17wUi = parcelRequire("17wUi");


var $gnYQc = parcelRequire("gnYQc");


var $2DVQX = parcelRequire("2DVQX");


var $7ZzSP = parcelRequire("7ZzSP");


var $7LuKf = parcelRequire("7LuKf");





var $6g1oe = parcelRequire("6g1oe");


var $4xcIM = parcelRequire("4xcIM");


var $2FNjD = parcelRequire("2FNjD");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $cryCi = parcelRequire("cryCi");


var $dBmJE = parcelRequire("dBmJE");








var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $lonEO = parcelRequire("lonEO");


var $iJELi = parcelRequire("iJELi");


var $d5ap9 = parcelRequire("d5ap9");


var $hmRc4 = parcelRequire("hmRc4");


var $fcF01 = parcelRequire("fcF01");


var $iJiK8 = parcelRequire("iJiK8");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $25MM7 = parcelRequire("25MM7");





var $jVK0t = parcelRequire("jVK0t");


var $64KID = parcelRequire("64KID");


var $kZDrw = parcelRequire("kZDrw");


var $8n9tL = parcelRequire("8n9tL");


var $1ytiN = parcelRequire("1ytiN");


var $a5txT = parcelRequire("a5txT");


var $97W74 = parcelRequire("97W74");


var $3tMMZ = parcelRequire("3tMMZ");


var $9wGTI = parcelRequire("9wGTI");


var $3e6Uc = parcelRequire("3e6Uc");

const $7db816b9e13721ff$var$defaultRelayEnvironment = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));
class $7db816b9e13721ff$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { store: store } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                (0, $a5txT.getStandalonePageTreeStateUpdater)()
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: (0, $hp2SH.getApolloClient)(),
            relayEnvironment: (0, $9wGTI.fg)('cfe_use_default_relay_env') ? $7db816b9e13721ff$var$defaultRelayEnvironment : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
            history: this.browserHistory,
            context: (0, $kFqI2.ReactReduxContext)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
            namedRoutes: (0, $64KID.namedRoutes)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), this.props.children))))))))))));
    }
    constructor(...args){
        super(...args);
        this.browserHistory = (0, $hmRc4.getBrowserHistory)();
    }
}
$7db816b9e13721ff$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    /**
   * Children Component
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    /**
   * Indicates if the component is rendered as Root
   */ renderAsRoot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");

const $d4f95b5cede9219f$var$store = (0, $3Tw8v.default)({
    isServerRenderedPage: true
});
(0, $9F7Qb.subscribe)($d4f95b5cede9219f$var$store);
/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */ const $d4f95b5cede9219f$var$renderComponentIntoDOM = (children, container, renderAsRoot = false)=>{
    if (typeof container === 'string') container = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.getElementById(container);
    const Component = ({ sessionData: sessionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7db816b9e13721ff$export$2e2bcd8739ae039), {
            store: $d4f95b5cede9219f$var$store,
            renderAsRoot: renderAsRoot
        }, children)));
    Component.propTypes = {
        sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
    };
    (0, $ge2sX.getSessionData)().then((sessionData)=>{
        const concurrentComponentWrapper = (0, $2FNjD.createRoot)(container);
        concurrentComponentWrapper.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            sessionData: sessionData
        }));
    });
};
var $d4f95b5cede9219f$export$2e2bcd8739ae039 = $d4f95b5cede9219f$var$renderComponentIntoDOM;



var $7RVQB = parcelRequire("7RVQB");




/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */ const $8bee1fe38b9eef04$var$mainSectionsSelectors = [
    '#main',
    '#admin-content',
    '#custom-content-container',
    '.ap-servlet-placeholder'
];
const $8bee1fe38b9eef04$export$ed04e7f6ba662aee = ()=>{
    const head = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.head || (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('head');
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createElement('style');
    const css = `${$8bee1fe38b9eef04$var$mainSectionsSelectors.join(',')} { opacity: 0 };`;
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createTextNode(css));
    if (head) head.appendChild(style);
};
const $8bee1fe38b9eef04$export$4011f4c5a8044281 = (runs = 0)=>{
    const mainContainers = $8bee1fe38b9eef04$var$mainSectionsSelectors.map((selector)=>(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector(selector)).filter((ele)=>ele !== null);
    if (mainContainers.length) mainContainers.forEach((container)=>{
        if (container) {
            container.style.transition = 'opacity .15s ease-in';
            container.style.opacity = '1';
        }
    });
    else // accounting for any race condition that could delay the parsing of the content
    if (runs < 5) {
        console.warn('Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet');
        setTimeout(()=>$8bee1fe38b9eef04$export$4011f4c5a8044281(runs + 1), 100);
    } else console.error('Legacy pages: content container was not found');
};






var $iyEDi = parcelRequire("iyEDi");


var $gnnzK = parcelRequire("gnnzK");


var $1NBp8 = parcelRequire("1NBp8");

/* StandaloneConfluenceNavigation.js generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $3pfAb = parcelRequire("3pfAb");


var $NAPtM = parcelRequire("NAPtM");


var $3u0dr = parcelRequire("3u0dr");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");











var $aXWIB = parcelRequire("aXWIB");


var $30qWc = parcelRequire("30qWc");





var $gqqjz = parcelRequire("gqqjz");








var $b1HmN = parcelRequire("b1HmN");

/**
 * @generated SignedSource<<6b503202439d8e121e3c7c0c5c0df5fa>>
 * @relayHash 737a60122b0a1fbdaa4709876ac5fba5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea
const $d6dcaac643994a17$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentRestrictionsPageResponse",
            "kind": "LinkedField",
            "name": "clearRestrictionsForFree",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "restrictionsHash"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "737a60122b0a1fbdaa4709876ac5fba5",
            "id": "f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea",
            "metadata": {},
            "name": "ChangeEditionClearRestrictionsForFreeMutation",
            "operationKind": "mutation",
            "text": "mutation ChangeEditionClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}"
        }
    };
}();
$d6dcaac643994a17$var$node.hash = "a6f31038cfbb195a7ec707513d6d3235";
var $d6dcaac643994a17$export$2e2bcd8739ae039 = $d6dcaac643994a17$var$node;


const $c9e67d6bb8fbd3cb$export$c8d7574a93f4b7d4 = (0, $d6dcaac643994a17$export$2e2bcd8739ae039);


const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $aXWIB.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $aXWIB.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $c9e67d6bb8fbd3cb$export$c8d7574a93f4b7d4),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $aXWIB.injectIntl)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);


















var $frIzR = parcelRequire("frIzR");











var $4WmbV = parcelRequire("4WmbV");

const $4c2daaa3bc0c282d$var$i18n = (0, $aXWIB.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    let t0;
    if ($[0] !== formatMessage || $[1] !== title) {
        t0 = formatMessage(title);
        $[0] = formatMessage;
        $[1] = title;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== body || $[4] !== formatMessage) {
        t1 = formatMessage(body);
        $[3] = body;
        $[4] = formatMessage;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            title: t0,
            body: t1,
            source: "auditLogs"
        });
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};


















var $f7Bnv = parcelRequire("f7Bnv");




const $ee74963fbde2c4ed$var$i18n = (0, $aXWIB.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { grandfathered: grandfathered, isSiteAdmin: isSiteAdmin } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let T0;
    let t1;
    let t2;
    if ($[0] !== grandfathered || $[1] !== intl || $[2] !== isSiteAdmin) {
        const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
        const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
        T0 = (0, $4WmbV.ChangeEditionSectionMessage);
        if ($[6] !== intl || $[7] !== title) {
            t1 = intl.formatMessage(title);
            $[6] = intl;
            $[7] = title;
            $[8] = t1;
        } else t1 = $[8];
        t2 = intl.formatMessage(bodyText);
        $[0] = grandfathered;
        $[1] = intl;
        $[2] = isSiteAdmin;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    let t3;
    if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            title: t1,
            body: t2,
            source: "individualSpaceRestrictedPages"
        });
        $[9] = T0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $aXWIB.useIntl)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);


const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $42omo.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $ee74963fbde2c4ed$export$51350d82d36f7e43),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $4c2daaa3bc0c282d$export$cb2ba78fe55aff74)
        };
    }
}


const $f60f9bb0af41c642$export$ddc928ad192d2b94 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $bQm3c.useSessionData)().edition === "FREE" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;
} : ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;






var $4PPzL = parcelRequire("4PPzL");


var $04e9M = parcelRequire("04e9M");


var $56QzY = parcelRequire("56QzY");


var $1dnxO = parcelRequire("1dnxO");


var $aeSHO = parcelRequire("aeSHO");


var $iJ8K8 = parcelRequire("iJ8K8");


var $lFjPc = parcelRequire("lFjPc");


var $5ZPtT = parcelRequire("5ZPtT");


var $eWwvy = parcelRequire("eWwvy");


var $39rFu = parcelRequire("39rFu");





var $cBuRD = parcelRequire("cBuRD");





var $eIKcA = parcelRequire("eIKcA");





var $ezLwY = parcelRequire("ezLwY");

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */ function $089e60b6c1a73ffc$var$shortcutContext(context) {
    return (BaseComponent)=>{
        class ShortcutContextComponent extends (0, $42omo.Component) {
            componentDidMount() {
                (0, $ezLwY.enableContext)(context);
            }
            componentWillUnmount() {
                (0, $ezLwY.disableContext)(context);
            }
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, this.props);
            }
        }
        ShortcutContextComponent.displayName = `ShortcutContextComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return ShortcutContextComponent;
    };
}
var $089e60b6c1a73ffc$export$2e2bcd8739ae039 = $089e60b6c1a73ffc$var$shortcutContext;



var $jmjWc = parcelRequire("jmjWc");


const $f05a18473f890654$export$ffff49ea750347f8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3CTAv",
    name: "StandaloneRestrictedPageOrSpace",
    loader: async ()=>(await (parcelRequire("fmuCC"))).StandaloneRestrictedPageOrSpace
});



var $jwv1p = parcelRequire("jwv1p");


var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $4QflW = parcelRequire("4QflW");





var $ba9cbe60fdf9141e$exports = {};

var $bCMS0 = parcelRequire("bCMS0");


var $daAKm = parcelRequire("daAKm");


var $ehlgT = parcelRequire("ehlgT");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $ba9cbe60fdf9141e$var$endsWith(string, target, position) {
    string = $fPVB6(string);
    target = $daAKm(target);
    var length = string.length;
    position = position === undefined ? length : $bCMS0($ehlgT(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$ba9cbe60fdf9141e$exports = $ba9cbe60fdf9141e$var$endsWith;



var $jzEl8 = parcelRequire("jzEl8");

const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED = [
    '#action-page-permissions-link'
];
const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = [
    '#page-favourite',
    '#action-menu-link'
];
const $9117dce6b863f439$var$replacedPlaceholder = {
    elementName: 'span',
    attributes: {
        style: `display: none`
    }
};
function $9117dce6b863f439$export$9e2c81a475b5d1b8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED,
        attempts: 100,
        retryDelay: 500,
        portalNode: null,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ba9cbe60fdf9141e$exports)))(window.location.pathname, '/pages/viewinfo.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION,
        attempts: 100,
        retryDelay: 500,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder,
        portalNode: null
    }));
}












var $inPa6 = parcelRequire("inPa6");








const $b82761c2a95901d5$export$18a8a22069631f81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kdP2C",
    loader: async ()=>(await (parcelRequire("gXX8A"))).ArchiveSpacePortal,
    name: 'ArchiveSpacePortal'
});






const $e87d969ba20a20a0$export$854f67824ef9311 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "P3ji1",
    loader: async ()=>(await (parcelRequire("2NJWg"))).DeleteSpacePortal,
    name: 'DeleteSpacePortal'
});






const $a6c6b76f924ecb80$export$b4b583c595949768 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BlJ6r",
    name: "LazySpaceSettingsForgeExtensionPortal",
    loader: async ()=>(await (parcelRequire("cq0jI"))).SpaceSettingsForgeExtensionPortal
});
$a6c6b76f924ecb80$export$b4b583c595949768.displayName = 'LazySpaceSettingsForgeExtensionPortal';



var $7QM6o = parcelRequire("7QM6o");


var $feuG2 = parcelRequire("feuG2");





const $b270d87888ab1caf$export$cca256d7c562dc07 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTzRP",
    loader: async ()=>(await (parcelRequire("7nmkU"))).SpaceTrashPortal,
    name: 'SpaceTrashPortal'
});






const $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wu877",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("7Y3RT"))).SiteSettingsHelpPanelLink
});






const $406f60e313bf3a3f$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h3QZB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("2fhln"))).BackupManagerButton
});



var $14QAi = parcelRequire("14QAi");


var $ep3mz = parcelRequire("ep3mz");

/* PdfBannerPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");





var $6mKj3 = parcelRequire("6mKj3");

const $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID = 'pdf-export-banner-root';
const $530cf45a0f14746c$var$i18n = (0, $aXWIB.defineMessages)({
    bannerMessage: {
        id: "pdf-export.banner.message",
        defaultMessage: "We've received your print request. To maintain your page's format, we're exporting it to a PDF for you to download and print."
    }
});
const $530cf45a0f14746c$var$styles = {
    bannerStyles: "_1yt4pxbi _bfhk1aqn _1bto1l2s _o5721q9c"
};
const $530cf45a0f14746c$var$PdfBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $530cf45a0f14746c$var$styles.bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $530cf45a0f14746c$var$i18n.bannerMessage)));
const $530cf45a0f14746c$export$57cc11a378563774 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    if (!(0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true)) return null;
     // only inject if ?showPdfBanner=true
    if (queryParams.showPdfBanner !== 'true') return null;
    let targetElement = document.getElementById($530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID); // if the target doesn't exist, create and insert it before <main>
    if (!targetElement) {
        const main = document.querySelector('main#main');
        if (main && main.parentElement) {
            targetElement = document.createElement('div');
            targetElement.id = $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID;
            main.parentElement.insertBefore(targetElement, main);
        }
    } // if no anchor could be found, bail
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($530cf45a0f14746c$var$PdfBanner, null), targetElement);
};


const $76c1a3880217c32d$var$i18n = (0, $aXWIB.defineMessages)({
    importingTemplates: {
        id: "standalone-navigation.importing.templates",
        defaultMessage: "More about importing templates"
    }
});
const $76c1a3880217c32d$export$fc287ab47b11c4ec = ({ spaceKey: spaceKey, isSpaceSettingsScreen: isSpaceSettingsScreen })=>{
    const { location: { pathname: pathname } } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $42omo.useEffect)(()=>{
        const { section: section, screen: screen } = (0, $14QAi.getRouteData)(pathname);
        // We only want analytics for IPH specific routes for now
        if (screen !== 'notTracked') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screen,
                attributes: {
                    section: section
                }
            }
        }).fire();
    }, [
        pathname,
        createAnalyticsEvent,
        spaceId
    ]);
    return pathname && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isSpaceSettingsScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageStateContainer), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsNavigationV2Portal), {
        spaceKey: spaceKey
    })) : null, pathname.includes('/spaces/archivespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b82761c2a95901d5$export$18a8a22069631f81), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/spaces/removespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e87d969ba20a20a0$export$854f67824ef9311), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/pages/viewtrash.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b270d87888ab1caf$export$cca256d7c562dc07), {
        spaceKey: spaceKey
    }), pathname.includes('/templatePackage/configurePlugin.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e), {
        articleId: "7p0QTJJI0VkoU49M4GzKH2",
        articleTopic: "admin-import-templates",
        portalTargetId: "site-settings-import",
        buttonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $76c1a3880217c32d$var$i18n.importingTemplates),
        pathname: pathname,
        routeGroup: "site-settings",
        routeName: "undefined"
    }), pathname.includes('/plugins/servlet/ondemandbackupmanager') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $406f60e313bf3a3f$export$b52880da76836cd4), {
        pathname: pathname
    }), pathname.includes('spaces/flyingpdf/pdfpageexport.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $530cf45a0f14746c$export$57cc11a378563774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6c6b76f924ecb80$export$b4b583c595949768), {
        spaceKey: spaceKey
    }));
};
// needed for react-proptypes warning
$76c1a3880217c32d$export$fc287ab47b11c4ec.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};


var $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation;
function $7c0ba11073bcb5f1$var$_defineProperty(e, r, t) {
    return (r = $7c0ba11073bcb5f1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c0ba11073bcb5f1$var$_toPropertyKey(t) {
    var i = $7c0ba11073bcb5f1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c0ba11073bcb5f1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7c0ba11073bcb5f1$var$TopNavSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1bsb1osq _4t3iymf6",
            __cmplp.className
        ])
    });
});
var $7c0ba11073bcb5f1$export$2e2bcd8739ae039 = (0, $089e60b6c1a73ffc$export$2e2bcd8739ae039)('global')(($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation = class StandaloneConfluenceNavigation extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { isAdminScreen: isAdminScreen } = this.props; // if admin screen, show content as we mount
        if (isAdminScreen) (0, $8bee1fe38b9eef04$export$4011f4c5a8044281)();
        else setTimeout((0, $8bee1fe38b9eef04$export$4011f4c5a8044281), 300);
        (0, $ge2sX.getSessionData)();
    }
    render() {
        const { isAdminScreen: isAdminScreen, isSpaceSettingsScreen: isSpaceSettingsScreen, isSpaceScreen: isSpaceScreen, route: route, spaceKey: spaceKey } = this.props;
        let navView;
        if ((0, $1dnxO.getIsNav4Enabled)() && isSpaceSettingsScreen) navView = (0, $lFjPc.CONTAINER_ADMIN_HOME_ID);
        else if (isSpaceSettingsScreen || isSpaceScreen) navView = (0, $lFjPc.CONTAINER_HOME_ID);
        else if (isAdminScreen) navView = (0, $lFjPc.ADMIN_HOME_ID);
        else if (route?.name !== (0, $1NBp8.EXTERNAL_SHARE).name) // XXX EXTERNAL_SHARE does not have the typical navigation.
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f05a18473f890654$export$ffff49ea750347f8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76c1a3880217c32d$export$fc287ab47b11c4ec), {
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
            nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
            livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
            screenEvent: {
                name: 'serverRenderedScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW)
            }
        }, navView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ZPtT.PageLayout), {
            view: navView,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            standalone: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), isSpaceSettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            entryPoint: "spaceSettings"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9117dce6b863f439$export$9e2c81a475b5d1b8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f60f9bb0af41c642$export$ddc928ad192d2b94), null));
    }
    constructor(...args){
        super(...args);
        $7c0ba11073bcb5f1$var$_defineProperty(this, "spacer", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c0ba11073bcb5f1$var$TopNavSpacer, {
                "data-test-id": "top-nav-spacer"
            }));
    }
}, $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "displayName", 'StandaloneConfluenceNavigation'), $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "propTypes", {
    isAdminScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    route: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
}), $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation));


const $fe485fa379bdff14$var$getSpaceKey = (state)=>{
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    return (0, $iyEDi.routerStateExists)(state) && routeParams && routeParams.spaceKey || state.meta.get('space-alias') || state.meta.get('space-key');
};
const $fe485fa379bdff14$var$mapStateToProps = (state, props)=>{
    const { location: location, matchRoute: matchRoute } = props;
    const isSpaceScreen = state.meta.get('is-space-page') === 'true' || (0, $gnnzK.isContentTypeOf)('page', state) || (0, $gnnzK.isContentTypeOf)('blogpost', state);
    //On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
    //use the spaceKey. Set spaceKey to null if on this path
    const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);
    const spaceKey = route?.name === (0, $1NBp8.DELETE_SPACE_LEGACY).name ? null : $fe485fa379bdff14$var$getSpaceKey(state);
    return {
        isAdminScreen: state.meta.get('is-admin-page') === 'true',
        isSpaceScreen: isSpaceScreen,
        isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
        route: route,
        spaceKey: spaceKey
    };
};
var $fe485fa379bdff14$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($fe485fa379bdff14$var$mapStateToProps)((0, $7c0ba11073bcb5f1$export$2e2bcd8739ae039));


/**
 * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
 * This ensures we catch and track any errors that occur during the app's initialization,
 * including async operations and React rendering. Moving this call later would risk missing
 * early errors.
 * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
 */ (0, $5QpZa.default)();
const $f5e2aff200456a49$var$sessionDataPromise = (async ()=>{
    (0, $hp2SH.getApolloClient)();
    try {
        const sessionData = await (0, $aXEzU.getSessionDataAndInitializeStatsig)();
        // Initialize browser storage controls after Statsig is ready (for proper feature gate evaluation)
        // This must happen before initializeStorageManager
        await (0, $7ZzSP.initializeBootstrapStorage)({
            userId: sessionData.userId,
            cloudId: sessionData.cloudId
        });
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        await (0, $17wUi.initializeStorageManager)({
            userId: userId,
            isLicensed: isLicensed
        });
        (0, $gnYQc.applyPersistedStatsigOverrides)();
        return sessionData;
    } catch  {
        // For the same reasons as in the non-standalone case documented in the
        // counterpart of this file which is
        // confluence/packages/confluence-frontend-server/src/index.js at the moment
        return (0, $iC5L0.getEmptySessionData)();
    }
})();
const $f5e2aff200456a49$var$translationPromise = (0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage));
Promise.all([
    $f5e2aff200456a49$var$sessionDataPromise,
    $f5e2aff200456a49$var$translationPromise
]).then(([sessionData])=>{
    const browserNotSupportedCheck = (0, $2DVQX.coreBrowserNotSupported)();
    // the only requirement for BrowserNotSupported to render is the translationPromise
    if (browserNotSupportedCheck) {
        // the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
        const documentBody = document.getElementById('com-atlassian-confluence');
        // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), documentBody);
    }
    (0, $7LuKf.initialization)(sessionData);
    (0, $8bee1fe38b9eef04$export$ed04e7f6ba662aee)();
    (0, $d4f95b5cede9219f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6baa9171970034d$export$11eb671888ed6e7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe485fa379bdff14$export$2e2bcd8739ae039), {
            apolloClient: (0, $hp2SH.getApolloClient)(),
            location: location,
            matchRoute: matchRoute
        }))), 'ui-global-sidebar-section', true);
});
 }, ["7EorR","5BbvB","lgZdI","aZinD","eiF7i","hhss7","ffEVr","5pvpJ","cEqm7","6XCf4","1yVM6","1qlDN","6wr18"]);

$parcel$global.rlb("3pblT")
//# sourceMappingURL=standalone-navigation-jquery3.28598375.js.map
